import { merge } from '@/helpers/Utility';
import { FC, HTMLAttributes } from 'react';

interface ContentContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const ContentContainer: FC<ContentContainerProps> = ({ className, children, ...rest }) => (
  <div className={merge('w-full max-w-md mx-auto', className)} {...rest}>
    {children}
  </div>
);
